import getExtensionInstance from "../extensions/getExtensionInstance.ts";
import ToShopLicensesDialog from "../modelDialogs/ToShopLicensesDialog.tsx";
import { ProjectLicenseType } from "../models/ProjectLicense.ts";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher.tsx";
import { itx } from "../translationItx/itx.ts";
import { MenuGroup, SimpleMenuButton } from "./Menubar.tsx";

export default function Menubar_Extensions() {
  useOnChangeWatcher(state.showMenubarGroup_tools);

  return (
    <MenuGroup
      //        style={{ width: "100px" }} // title isn`t shown correct
      title={"Export"} // no itx
    >
      <SimpleMenuButton
        id="tools"
        iconName="file-export" // no itx
        text={itx("menubarTools.export", "Export")}
        onClick={() => {
          state.showMenubarGroup_tools.value = !state.showMenubarGroup_tools.value;
        }}
      />

      {state.showMenubarGroup_tools.value && (
        <SimpleMenuButton
          icon={
            <div
              style={{
                fontSize: "8px",
                border: "1px solid black",
                borderRadius: "25px",
                width: "25px",
                height: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              GIRA
            </div>
          } // no itx
          text={itx("menubarTools.giraExport", "Gira Export")}
          onClick={async () => {
            if (state.projectLicense.checkLicenses(ProjectLicenseType.GiraExport)) {
              const giraExport = await getExtensionInstance("gira_GPA"); // no itx
              giraExport && giraExport.execute("");
            } else {
              state.dialogManager.openDialog(<ToShopLicensesDialog />);
            }
          }}
        />
      )}
    </MenuGroup>
  );
}
